 <div class="slider-display" *ngIf="(ieListType.EntityList.RowItems.length > 0)"  >
  <div class="col-md-4"> <h5>{{displayName}}</h5></div>
  <div class="col-md-5">
  <nouislider #slider
    [id] = "sliderTypeID"
    [connect]="true" [min]="min" [max]="max"
    [step]="step"
    [(ngModel)]="selected"
    [tooltips]="tooltipdisplay"
    (ngModelChange)="onSliderChange($event)"
    [disabled]="false">
  </nouislider>
</div>
</div>